import client from './client';

export async function fetchBilling() {
  const response = await client.get('/api/billing');
  return response.data;
}

export async function createCheckout(data) {
  const response = await client.post('/api/billing/checkout', data);
  return response.data;
}

export async function createPortalSession() {
  const response = await client.post('/api/billing/portal');
  return response.data;
}
